export default "__VITE_ASSET__Bu7jlEL7__"